import _concat from "lodash/concat";
import faq from "./faq";

export default {
  path: "/faq",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(faq)
};
